"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoggerConf = exports.Logger = exports.initCustomLogger = void 0;
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'spettatore_bi' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 2 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'spettatore_bi' });
    }
    ;
    /**
    * @typedef {Object} flashLoginSignupErrorEmailIsNotValidParams
    * @property {undefined} docid - test
    * @property {GUID} siteid - test
    **/
    /**
     * Name: (flash login) signup error (email is not valid). Evid: 5.
    
    
     * docid - Type: obsolete_docid. Desc: test
     *
     * siteid - Type: guid. Desc: test
     * @param {flashLoginSignupErrorEmailIsNotValidParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.flashLoginSignupErrorEmailIsNotValid = function (params) {
        return this.bi.log(__assign({ evid: 5 }, params));
    };
    /**
    * @typedef {Object} templatesSwitchToDesktopParams
    * @property {string} category - the create page category
    * @property {Url} http_referrer - null
    * @property {Url} originappurl - only html template viewer send this property
    * @property {number} page_index - the category index of the template
    * @property {string} platform - null
    * @property {string} product - create page product filter
    * @property {number} siteType - null
    * @property {GUID} openingSiteID - null
    **/
    /**
     * Name: templates -> switch to desktop. Evid: 28.
    
    
     * category - Type: string. Desc: the create page category
     *
     * http_referrer - Type: url_with_parameters.
     *
     * originappurl - Type: url_with_parameters. Desc: only html template viewer send this property
     *
     * page_index - Type: numeric. Desc: the category index of the template
     *
     * platform - Type: string.
     *
     * product - Type: string. Desc: create page product filter
     *
     * siteType - Type: numeric.
     *
     * openingSiteID - Type: guid.
     * @param {templatesSwitchToDesktopParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesSwitchToDesktop = function (params) {
        return this.bi.log(__assign({ evid: 28 }, params));
    };
    /**
    * @typedef {Object} templatesPageSortTemplatesParams
    * @property {string} action - open/close/select
    * @property {string} book - CMS book name
    * @property {string} category - Current main category performed in
    * @property {string} previous_value - Previous sort used
    * @property {string} selected_value - (Optional) sort selected
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    **/
    /**
     * Name: templates page -> sort templates. Evid: 58.
     * Event description: Usage of templates sorting.
    
     * action - Type: string. Desc: open/close/select
     *
     * book - Type: string. Desc: CMS book name
     *
     * category - Type: string. Desc: Current main category performed in
     *
     * previous_value - Type: string. Desc: Previous sort used
     *
     * selected_value - Type: string. Desc: (Optional) sort selected
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     * @param {templatesPageSortTemplatesParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesPageSortTemplates = function (params) {
        return this.bi.log(__assign({ evid: 58 }, params));
    };
    /**
    * @typedef {Object} templatesPageSubCategoryFilterParams
    * @property {string} action - add/remove/clear all
    * @property {string} book - CMS book name
    * @property {string} category - Current main category performed in
    * @property {string} previous_value - Previous list before the update
    * @property {string} selected_value - (Optional) Subcategory clicked on
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    **/
    /**
     * Name: templates page -> sub-category filter. Evid: 56.
     * Event description: Usage of the sub-category filter.
    
     * action - Type: string. Desc: add/remove/clear all
     *
     * book - Type: string. Desc: CMS book name
     *
     * category - Type: string. Desc: Current main category performed in
     *
     * previous_value - Type: string. Desc: Previous list before the update
     *
     * selected_value - Type: string. Desc: (Optional) Subcategory clicked on
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     * @param {templatesPageSubCategoryFilterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesPageSubCategoryFilter = function (params) {
        return this.bi.log(__assign({ evid: 56 }, params));
    };
    /**
    * @typedef {Object} landingPageOpenEditorParams
    * @property {GUID} esi - the editor session. should be shared between client and server events
    * @property {number} galleryDocIndex - a zero-based index of the template on the page
    * @property {number} gallerydocsperpage - null
    * @property {string} landing_url - null
    * @property {Url} openingbrowserurl - null
    * @property {number} page_index - the category index of the template
    * @property {number} siteType - null
    * @property {GUID} openingSiteID - null
    **/
    /**
     * Name: landing page > open editor. Evid: 17.
    
    
     * esi - Type: guid. Desc: the editor session. should be shared between client and server events
     *
     * galleryDocIndex - Type: numeric. Desc: a zero-based index of the template on the page
     *
     * gallerydocsperpage - Type: numeric.
     *
     * landing_url - Type: string.
     *
     * openingbrowserurl - Type: url.
     *
     * page_index - Type: numeric. Desc: the category index of the template
     *
     * siteType - Type: numeric.
     *
     * openingSiteID - Type: guid.
     * @param {landingPageOpenEditorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.landingPageOpenEditor = function (params) {
        return this.bi.log(__assign({ evid: 17 }, params));
    };
    /**
    * @typedef {Object} test2Params
    
    **/
    /**
     * Name: test 2. Evid: 64.
     * Event description: User engagement with the Templates Page widget.
    
    
     * @param {test2Params} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.test2 = function (params) {
        return this.bi.log(__assign({ evid: 64 }, params));
    };
    /**
    * @typedef {Object} templatesPageGalleryFilterPaneParams
    * @property {string} action - open / close / select / unselect / hover / clear / show / hide
    * @property {string} book - CMS book name
    * @property {string} category - Current main category performed in
    * @property {string} clicked_value - the filter/sort value on which the user clicked (either to select or unselect)
    * @property {string} menu_name - features / colors / layouts / styles / sort / all
    * @property {string} previous_values - Previous list of values before the update
    * @property {string} subcategory - Current sub-category performed in
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    * @property {string} updated_colors - List of selected colors after the update
    * @property {string} updated_features - List of selected features after the update
    * @property {string} updated_layouts - List of selected layouts after the update
    * @property {string} updated_sorting - Applied sorting after the update
    * @property {string} updated_styles - List of selected styles after the update
    * @property {string} updated_values - List of selected values after the update
    **/
    /**
     * Name: templates page -> gallery filter pane. Evid: 99.
     * Event description: Usage of the templates page filter pane.
    
     * action - Type: string. Desc: open / close / select / unselect / hover / clear / show / hide
     *
     * book - Type: string. Desc: CMS book name
     *
     * category - Type: string. Desc: Current main category performed in
     *
     * clicked_value - Type: string. Desc: the filter/sort value on which the user clicked (either to select or unselect)
     *
     * menu_name - Type: string. Desc: features / colors / layouts / styles / sort / all
     *
     * previous_values - Type: string. Desc: Previous list of values before the update
     *
     * subcategory - Type: string. Desc: Current sub-category performed in
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     *
     * updated_colors - Type: string. Desc: List of selected colors after the update
     *
     * updated_features - Type: string. Desc: List of selected features after the update
     *
     * updated_layouts - Type: string. Desc: List of selected layouts after the update
     *
     * updated_sorting - Type: string. Desc: Applied sorting after the update
     *
     * updated_styles - Type: string. Desc: List of selected styles after the update
     *
     * updated_values - Type: string. Desc: List of selected values after the update
     * @param {templatesPageGalleryFilterPaneParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesPageGalleryFilterPane = function (params) {
        return this.bi.log(__assign({ evid: 99 }, params));
    };
    /**
    * @typedef {Object} templatesSwitchToMobileParams
    * @property {string} category - the create page category
    * @property {Url} http_referrer - null
    * @property {Url} originappurl - only html template viewer send this property
    * @property {number} page_index - the category index of the template
    * @property {string} platform - null
    * @property {string} product - create page product filter
    * @property {number} siteType - null
    * @property {GUID} openingSiteID - null
    **/
    /**
     * Name: templates -> switch to mobile. Evid: 27.
    
    
     * category - Type: string. Desc: the create page category
     *
     * http_referrer - Type: url_with_parameters.
     *
     * originappurl - Type: url_with_parameters. Desc: only html template viewer send this property
     *
     * page_index - Type: numeric. Desc: the category index of the template
     *
     * platform - Type: string.
     *
     * product - Type: string. Desc: create page product filter
     *
     * siteType - Type: numeric.
     *
     * openingSiteID - Type: guid.
     * @param {templatesSwitchToMobileParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesSwitchToMobile = function (params) {
        return this.bi.log(__assign({ evid: 27 }, params));
    };
    /**
    * @typedef {Object} templatesVideoPreviewEndedParams
    * @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
    * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
    * @property {string} book - book
    * @property {string} category - the create page category
    * @property {string} colors - list of selected colors
    * @property {string} features - list of selected features
    * @property {number} gallerydocsperpage - gallery docs per page
    * @property {boolean} btn - is_button
    * @property {boolean} is_search_result - Is result from suggestion ("like you")
    * @property {string} layouts - list of selected layouts
    * @property {Url} openingbrowserurl - opening browser url
    * @property {string} origin - origin
    * @property {number} screen_height - Height of client device screen
    * @property {number} screen_width - Width of client device screen
    * @property {GUID} search_guid - (optional) If from search results, GUID of matching search
    * @property {number} search_rank - External ("like you") suggestion ranking
    * @property {number} siteType - site_type
    * @property {string} sorting - selected sorting
    * @property {string} styles - list of selected styles
    * @property {string} sub_category - List of subcategory filters
    * @property {GUID} openingSiteID - template_id
    * @property {number} total_search_results - total search results from external ("like you") search suggestion
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    * @property {DateTime} video_end_time - thumbnail video end timestamp
    * @property {DateTime} video_start_time - thumbnail video start timestamp
    * @property {string} video_status - stopped/ended/loading
    * @property {number} window_height - Initial height of client window
    * @property {number} window_width - Initial width of client window
    **/
    /**
     * Name: templates -> video preview ended. Evid: 73.
     * Event description: when the video in preview mode ended/stopped.
    
     * avail_height - Type: numeric. Desc: Returns the amount of vertical space in pixels available to the window
     *
     * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
     *
     * book - Type: string. Desc: book
     *
     * category - Type: string. Desc: the create page category
     *
     * colors - Type: string. Desc: list of selected colors
     *
     * features - Type: string. Desc: list of selected features
     *
     * gallerydocsperpage - Type: numeric. Desc: gallery docs per page
     *
     * btn - Type: bool. Desc: is_button
     *
     * is_search_result - Type: bool. Desc: Is result from suggestion ("like you")
     *
     * layouts - Type: string. Desc: list of selected layouts
     *
     * openingbrowserurl - Type: url. Desc: opening browser url
     *
     * origin - Type: string. Desc: origin
     *
     * screen_height - Type: numeric. Desc: Height of client device screen
     *
     * screen_width - Type: numeric. Desc: Width of client device screen
     *
     * search_guid - Type: guid. Desc: (optional) If from search results, GUID of matching search
     *
     * search_rank - Type: numeric. Desc: External ("like you") suggestion ranking
     *
     * siteType - Type: numeric. Desc: site_type
     *
     * sorting - Type: string. Desc: selected sorting
     *
     * styles - Type: string. Desc: list of selected styles
     *
     * sub_category - Type: string. Desc: List of subcategory filters
     *
     * openingSiteID - Type: guid. Desc: template_id
     *
     * total_search_results - Type: numeric. Desc: total search results from external ("like you") search suggestion
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     *
     * video_end_time - Type: datetime. Desc: thumbnail video end timestamp
     *
     * video_start_time - Type: datetime. Desc: thumbnail video start timestamp
     *
     * video_status - Type: string. Desc: stopped/ended/loading
     *
     * window_height - Type: numeric. Desc: Initial height of client window
     *
     * window_width - Type: numeric. Desc: Initial width of client window
     * @param {templatesVideoPreviewEndedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesVideoPreviewEnded = function (params) {
        return this.bi.log(__assign({ evid: 73 }, params));
    };
    /**
    * @typedef {Object} templatesWidgetLoadedParams
    * @property {number} avail_height - Returns the amount of horizontal space in pixels vertical to the window
    * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
    * @property {string} category - Main category name
    * @property {number} screen_height - Height of client device screen
    * @property {number} screen_width - Width of client device screen
    * @property {string} sub_category - List of subcategory filters
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    * @property {string} widget_name - The vertical presented in the Widget (Blog, Online Store, etc.)
    * @property {number} window_height - Initial height of client window
    * @property {number} window_width - Initial width of client window
    **/
    /**
     * Name: templates -> Widget Loaded. Evid: 79.
     * Event description: Widget was loaded (not necessarily viewed).
    
     * avail_height - Type: numeric. Desc: Returns the amount of horizontal space in pixels vertical to the window
     *
     * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
     *
     * category - Type: string. Desc: Main category name
     *
     * screen_height - Type: numeric. Desc: Height of client device screen
     *
     * screen_width - Type: numeric. Desc: Width of client device screen
     *
     * sub_category - Type: string. Desc: List of subcategory filters
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     *
     * widget_name - Type: string. Desc: The vertical presented in the Widget (Blog, Online Store, etc.)
     *
     * window_height - Type: numeric. Desc: Initial height of client window
     *
     * window_width - Type: numeric. Desc: Initial width of client window
     * @param {templatesWidgetLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesWidgetLoaded = function (params) {
        return this.bi.log(__assign({ evid: 79 }, params));
    };
    /**
    * @typedef {Object} flashEditorGoToBlogParams
    
    **/
    /**
     * Name: (flash editor) go to blog. Evid: 60.
    
    
    
     * @param {flashEditorGoToBlogParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.flashEditorGoToBlog = function (params) {
        return this.bi.log(__assign({ evid: 60 }, params));
    };
    /**
    * @typedef {Object} templatesReadMoreParams
    * @property {Url} http_referrer - null
    * @property {string} category - the create page category
    * @property {number} galleryDocIndex - a zero-based index of the template on the page
    * @property {Url} originappurl - only html template viewer send this property
    * @property {number} page_index - the category index of the template
    * @property {string} platform - null
    * @property {string} product - create page product filter
    * @property {number} siteType - null
    * @property {GUID} openingSiteID - null
    **/
    /**
     * Name: templates -> read more. Evid: 19.
    
    
     * http_referrer - Type: url.
     *
     * category - Type: string. Desc: the create page category
     *
     * galleryDocIndex - Type: numeric. Desc: a zero-based index of the template on the page
     *
     * originappurl - Type: url_with_parameters. Desc: only html template viewer send this property
     *
     * page_index - Type: numeric. Desc: the category index of the template
     *
     * platform - Type: string.
     *
     * product - Type: string. Desc: create page product filter
     *
     * siteType - Type: numeric.
     *
     * openingSiteID - Type: guid.
     * @param {templatesReadMoreParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesReadMore = function (params) {
        return this.bi.log(__assign({ evid: 19 }, params));
    };
    /**
    * @typedef {Object} templatesPagePageFullyRenderedParams
    * @property {string} book - book
    * @property {string} category - the create page category
    * @property {string} colors - list of selected colors
    * @property {string} event_data - data about templates loaded
    * @property {string} features - list of selected features
    * @property {number} gallerydocsperpage - Number of thumbnails on page
    * @property {string} interaction_type - Type of templates page interaction
    * @property {string} layouts - list of selected layouts
    * @property {number} loadingTime - Time to full rendering (interactive)
    * @property {string} origin - origin page
    * @property {string} referralInfo - -
    * @property {string} sorting - selected sorting
    * @property {string} styles - list of selected styles
    * @property {string} sub_category - List of subcategory filters
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    **/
    /**
     * Name: Templates Page -> Page fully rendered. Evid: 51.
     * Event description: Templates page interaction is fully rendered and interactive to user.
    
     * book - Type: string. Desc: book
     *
     * category - Type: string. Desc: the create page category
     *
     * colors - Type: string. Desc: list of selected colors
     *
     * event_data - Type: string. Desc: data about templates loaded
     *
     * features - Type: string. Desc: list of selected features
     *
     * gallerydocsperpage - Type: numeric. Desc: Number of thumbnails on page
     *
     * interaction_type - Type: string. Desc: Type of templates page interaction
     *
     * layouts - Type: string. Desc: list of selected layouts
     *
     * loadingTime - Type: numeric. Desc: Time to full rendering (interactive)
     *
     * origin - Type: string. Desc: origin page
     *
     * referralInfo - Type: string. Desc: -
     *
     * sorting - Type: string. Desc: selected sorting
     *
     * styles - Type: string. Desc: list of selected styles
     *
     * sub_category - Type: string. Desc: List of subcategory filters
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     * @param {templatesPagePageFullyRenderedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesPagePageFullyRendered = function (params) {
        return this.bi.log(__assign({ evid: 51 }, params));
    };
    /**
    * @typedef {Object} oldTemplateViewerTemplateViewerOpenedATemplateParams
    * @property {Url} app - null
    * @property {Url} app_url - null
    * @property {undefined} docid - null
    **/
    /**
     * Name: (old template viewer) template viewer opened a template. Evid: 34.
    
    
     * app - Type: url.
     *
     * app_url - Type: url.
     *
     * docid - Type: obsolete_docid.
     * @param {oldTemplateViewerTemplateViewerOpenedATemplateParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oldTemplateViewerTemplateViewerOpenedATemplate = function (params) {
        return this.bi.log(__assign({ evid: 34 }, params));
    };
    /**
    * @typedef {Object} templatesClickedDescriptionParams
    * @property {number} galleryDocsPerPage - gallery docs per page
    * @property {GUID} tpsi - Templates Page Session ID
    **/
    /**
     * Name: templates -> clicked description. Evid: 24.
    
    
     * galleryDocsPerPage - Type: numeric. Desc: gallery docs per page
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID
     * @param {templatesClickedDescriptionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesClickedDescription = function (params) {
        return this.bi.log(__assign({ evid: 24 }, params));
    };
    /**
    * @typedef {Object} templatesStartNowAdiBuilderParams
    * @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
    * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
    * @property {string} criteria - Criteria searched
    * @property {GUID} esi - ESI guid
    * @property {Url} openingBrowserUrl - openingBrowserUrl
    * @property {number} screen_height - Height of client device screen
    * @property {number} screen_width - Width of client device screen
    * @property {string} template_type - ADI template or Editor template
    * @property {number} total_suggested_results - total search results from external search suggestion
    * @property {number} window_height - Initial height of client window
    * @property {number} window_width - Initial width of client window
    * @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
    **/
    /**
     * Name: templates -> "Start Now" ADI builder. Evid: 50.
     * Event description: Clicking the "Start Now" ADI builder from no results search.
    
     * avail_height - Type: numeric. Desc: Returns the amount of vertical space in pixels available to the window
     *
     * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
     *
     * criteria - Type: string. Desc: Criteria searched
     *
     * esi - Type: guid. Desc: ESI guid
     *
     * openingBrowserUrl - Type: url. Desc: openingBrowserUrl
     *
     * screen_height - Type: numeric. Desc: Height of client device screen
     *
     * screen_width - Type: numeric. Desc: Width of client device screen
     *
     * template_type - Type: string. Desc: ADI template or Editor template
     *
     * total_suggested_results - Type: numeric. Desc: total search results from external search suggestion
     *
     * window_height - Type: numeric. Desc: Initial height of client window
     *
     * window_width - Type: numeric. Desc: Initial width of client window
     *
     * wixsession - Type: string. Desc: authentication token. if the session exists, then the user is logged in.
     * @param {templatesStartNowAdiBuilderParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesStartNowAdiBuilder = function (params) {
        return this.bi.log(__assign({ evid: 50 }, params));
    };
    /**
    * @typedef {Object} templatesWidgetActionsParams
    * @property {number} avail_height - Returns the amount of horizontal space in pixels vertical to the window
    * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
    * @property {string} book - book
    * @property {string} category - Main category name
    * @property {string} clicked_element - Clicked Element: Thumbnail, Title, etc.
    * @property {number} screen_height - Height of client device screen
    * @property {number} screen_width - Width of client device screen
    * @property {string} sub_category - List of subcategory filters
    * @property {number} tool_index - (optional)  Tool index number (1..4)
    * @property {number} tool_index_selected - (optional) Tool number to be presented
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    * @property {string} widget_name - The vertical presented in the Widget (Blog, Online Store, etc.)
    * @property {number} window_height - Initial height of client window
    * @property {number} window_width - Initial width of client window
    **/
    /**
     * Name: templates -> Widget Actions. Evid: 62.
     * Event description: User engagement with the Templates Page widget.
    
     * avail_height - Type: numeric. Desc: Returns the amount of horizontal space in pixels vertical to the window
     *
     * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
     *
     * book - Type: string. Desc: book
     *
     * category - Type: string. Desc: Main category name
     *
     * clicked_element - Type: string. Desc: Clicked Element: Thumbnail, Title, etc.
     *
     * screen_height - Type: numeric. Desc: Height of client device screen
     *
     * screen_width - Type: numeric. Desc: Width of client device screen
     *
     * sub_category - Type: string. Desc: List of subcategory filters
     *
     * tool_index - Type: numeric. Desc: (optional)  Tool index number (1..4)
     *
     * tool_index_selected - Type: numeric. Desc: (optional) Tool number to be presented
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     *
     * widget_name - Type: string. Desc: The vertical presented in the Widget (Blog, Online Store, etc.)
     *
     * window_height - Type: numeric. Desc: Initial height of client window
     *
     * window_width - Type: numeric. Desc: Initial width of client window
     * @param {templatesWidgetActionsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesWidgetActions = function (params) {
        return this.bi.log(__assign({ evid: 62 }, params));
    };
    /**
    * @typedef {Object} templatesHoverOnWidgetParams
    * @property {number} avail_height - Returns the amount of horizontal space in pixels vertical to the window
    * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
    * @property {string} category - Main category name
    * @property {number} hover_ms - hover duration in milliseconds
    * @property {number} screen_height - Height of client device screen
    * @property {number} screen_width - Width of client device screen
    * @property {string} sub_category - List of subcategory filters
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    * @property {string} widget_name - The vertical presented in the Widget (Blog, Online Store, etc.)
    * @property {number} window_height - Initial height of client window
    * @property {number} window_width - Initial width of client window
    **/
    /**
     * Name: templates -> Hover on Widget. Evid: 80.
     * Event description: Hover on the widget.
    
     * avail_height - Type: numeric. Desc: Returns the amount of horizontal space in pixels vertical to the window
     *
     * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
     *
     * category - Type: string. Desc: Main category name
     *
     * hover_ms - Type: numeric. Desc: hover duration in milliseconds
     *
     * screen_height - Type: numeric. Desc: Height of client device screen
     *
     * screen_width - Type: numeric. Desc: Width of client device screen
     *
     * sub_category - Type: string. Desc: List of subcategory filters
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     *
     * widget_name - Type: string. Desc: The vertical presented in the Widget (Blog, Online Store, etc.)
     *
     * window_height - Type: numeric. Desc: Initial height of client window
     *
     * window_width - Type: numeric. Desc: Initial width of client window
     * @param {templatesHoverOnWidgetParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesHoverOnWidget = function (params) {
        return this.bi.log(__assign({ evid: 80 }, params));
    };
    /**
    * @typedef {Object} templatesViewTemplateSuccessfullyUploadedParams
    * @property {string} book - book
    * @property {string} category - the create page category
    * @property {number} galleryDocIndex - gallery_doc_index
    * @property {number} galleryDocsPerPage - gallerydocsperpage
    * @property {number} index - index
    * @property {number} loadingTime - loading time for template viewer
    * @property {Url} openingBrowserUrl - opening_browser_url
    * @property {string} origin - origin
    * @property {string} product - product
    * @property {number} siteType - siteType
    * @property {GUID} openingSiteID - openingSiteID
    **/
    /**
     * Name: templates -> view template successfully uploaded. Evid: 43.
     * Event description: template view was successfully uploaded.
    
     * book - Type: string. Desc: book
     *
     * category - Type: string. Desc: the create page category
     *
     * galleryDocIndex - Type: numeric. Desc: gallery_doc_index
     *
     * galleryDocsPerPage - Type: numeric. Desc: gallerydocsperpage
     *
     * index - Type: numeric. Desc: index
     *
     * loadingTime - Type: numeric. Desc: loading time for template viewer
     *
     * openingBrowserUrl - Type: url. Desc: opening_browser_url
     *
     * origin - Type: string. Desc: origin
     *
     * product - Type: string. Desc: product
     *
     * siteType - Type: numeric. Desc: siteType
     *
     * openingSiteID - Type: guid. Desc: openingSiteID
     * @param {templatesViewTemplateSuccessfullyUploadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesViewTemplateSuccessfullyUploaded = function (params) {
        return this.bi.log(__assign({ evid: 43 }, params));
    };
    /**
    * @typedef {Object} templatesPageMainCategoryMenuParams
    * @property {string} action - Open/Close/Select
    * @property {string} book - CMS book name
    * @property {string} category - Current main category performed in
    * @property {string} category_group - Category group (Business & Org, Store, etc.)
    * @property {string} click_source - Main Header/Sticky Header
    * @property {string} selected_sub_category - (Optional) chosen sub-category
    * @property {string} selected_value - (Optional) chosen category
    * @property {string} sub_category - Current sub-category performed in
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    **/
    /**
     * Name: templates page -> main category menu. Evid: 55.
     * Event description: Usage of the main category menu.
    
     * action - Type: string. Desc: Open/Close/Select
     *
     * book - Type: string. Desc: CMS book name
     *
     * category - Type: string. Desc: Current main category performed in
     *
     * category_group - Type: string. Desc: Category group (Business & Org, Store, etc.)
     *
     * click_source - Type: string. Desc: Main Header/Sticky Header
     *
     * selected_sub_category - Type: string. Desc: (Optional) chosen sub-category
     *
     * selected_value - Type: string. Desc: (Optional) chosen category
     *
     * sub_category - Type: string. Desc: Current sub-category performed in
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     * @param {templatesPageMainCategoryMenuParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesPageMainCategoryMenu = function (params) {
        return this.bi.log(__assign({ evid: 55 }, params));
    };
    /**
    * @typedef {Object} templatesPageTemplatesFilterPaneParams
    * @property {string} action - open/close/hover/select/clear all/show filters/hide filters
    * @property {string} book - CMS book name
    * @property {string} category - Current main category performed in
    * @property {string} filter_type - feature/color/layout/style (style relevant only for select action)
    * @property {string} previous_value - Previous list before the update
    * @property {string} selected_value - (Optional) feature/color/layout/style checked or cleared list
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    **/
    /**
     * Name: templates page -> templates filter pane. Evid: 57.
     * Event description: Usage of the templates filter pane.
    
     * action - Type: string. Desc: open/close/hover/select/clear all/show filters/hide filters
     *
     * book - Type: string. Desc: CMS book name
     *
     * category - Type: string. Desc: Current main category performed in
     *
     * filter_type - Type: string. Desc: feature/color/layout/style (style relevant only for select action)
     *
     * previous_value - Type: string. Desc: Previous list before the update
     *
     * selected_value - Type: string. Desc: (Optional) feature/color/layout/style checked or cleared list
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     * @param {templatesPageTemplatesFilterPaneParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesPageTemplatesFilterPane = function (params) {
        return this.bi.log(__assign({ evid: 57 }, params));
    };
    /**
    * @typedef {Object} templatesGenericPageViewParams
    * @property {number} avail_height - Returns the amount of horizontal space in pixels vertical to the window
    * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
    * @property {string} category - the create page category
    * @property {string} colors - list of selected colors
    * @property {string} criteria - search term used in search
    * @property {string} eventData - json with template list: returns the number of templates on the page that was loaded
    * @property {string} features - list of selected features
    * @property {number} gallerydocsperpage - number of templates presented on the page
    * @property {boolean} is_search_result - Is result from suggestion ("like you")
    * @property {string} layouts - list of selected layouts
    * @property {string} previous_url - previous URL (referrer)
    * @property {number} screen_height - Height of client device screen
    * @property {string} screen_type - category / search_results / main / home
    * @property {number} screen_width - Width of client device screen
    * @property {GUID} search_guid - If from search results, GUID of matching search
    * @property {number} search_rank - External ("like you") suggestion ranking
    * @property {string} sorting - selected sorting
    * @property {string} styles - list of selected styles
    * @property {string} sub_category - List of subcategory filters
    * @property {number} total_search_results - total search results from external ("like you") search suggestion
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    * @property {number} window_height - Initial height of client window
    * @property {number} window_width - Initial width of client window
    * @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
    **/
    /**
     * Name: templates -> generic page view. Evid: 78.
     * Event description: page load - templates page domain.
    
     * avail_height - Type: numeric. Desc: Returns the amount of horizontal space in pixels vertical to the window
     *
     * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
     *
     * category - Type: string. Desc: the create page category
     *
     * colors - Type: string. Desc: list of selected colors
     *
     * criteria - Type: string. Desc: search term used in search
     *
     * eventData - Type: string. Desc: json with template list: returns the number of templates on the page that was loaded
     *
     * features - Type: string. Desc: list of selected features
     *
     * gallerydocsperpage - Type: numeric. Desc: number of templates presented on the page
     *
     * is_search_result - Type: bool. Desc: Is result from suggestion ("like you")
     *
     * layouts - Type: string. Desc: list of selected layouts
     *
     * previous_url - Type: string. Desc: previous URL (referrer)
     *
     * screen_height - Type: numeric. Desc: Height of client device screen
     *
     * screen_type - Type: string. Desc: category / search_results / main / home
     *
     * screen_width - Type: numeric. Desc: Width of client device screen
     *
     * search_guid - Type: guid. Desc: If from search results, GUID of matching search
     *
     * search_rank - Type: numeric. Desc: External ("like you") suggestion ranking
     *
     * sorting - Type: string. Desc: selected sorting
     *
     * styles - Type: string. Desc: list of selected styles
     *
     * sub_category - Type: string. Desc: List of subcategory filters
     *
     * total_search_results - Type: numeric. Desc: total search results from external ("like you") search suggestion
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     *
     * window_height - Type: numeric. Desc: Initial height of client window
     *
     * window_width - Type: numeric. Desc: Initial width of client window
     *
     * wixsession - Type: string. Desc: authentication token. if the session exists, then the user is logged in.
     * @param {templatesGenericPageViewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesGenericPageView = function (params) {
        return this.bi.log(__assign({ evid: 78 }, params));
    };
    /**
    * @typedef {Object} oldTemplateViewerOldMyAccountOpenFlashEditorParams
    * @property {Url} app - null
    * @property {undefined} docid - null
    * @property {Url} openingbrowserurl - null
    * @property {GUID} siteid - null
    * @property {string} openingSiteID - null
    **/
    /**
     * Name: (old template viewer / old my account) open flash editor. Evid: 8.
    
    
     * app - Type: url.
     *
     * docid - Type: obsolete_docid.
     *
     * openingbrowserurl - Type: url.
     *
     * siteid - Type: guid.
     *
     * openingSiteID - Type: string.
     * @param {oldTemplateViewerOldMyAccountOpenFlashEditorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oldTemplateViewerOldMyAccountOpenFlashEditor = function (params) {
        return this.bi.log(__assign({ evid: 8 }, params));
    };
    /**
    * @typedef {Object} templatesPaginationParams
    * @property {string} category - Templates Page Category
    * @property {number} page_clicked_index - Next page's index chosen by user
    * @property {string} pagination_type - Page Click/Load More Button/Infinite Scroll
    * @property {GUID} tpsi - Templates Page Session ID
    **/
    /**
     * Name: Templates Page -> Pagination. Evid: 54.
     * Event description: User browsing through paginations.
    
     * category - Type: string. Desc: Templates Page Category
     *
     * page_clicked_index - Type: numeric. Desc: Next page's index chosen by user
     *
     * pagination_type - Type: string. Desc: Page Click/Load More Button/Infinite Scroll
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID
     * @param {templatesPaginationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesPagination = function (params) {
        return this.bi.log(__assign({ evid: 54 }, params));
    };
    /**
    * @typedef {Object} templateMixerStyleChangeParams
    * @property {string} style_name - null
    * @property {GUID} template_id - null
    **/
    /**
     * Name: template mixer -> style change. Evid: 33.
    
    
     * style_name - Type: string.
     *
     * template_id - Type: guid.
     * @param {templateMixerStyleChangeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templateMixerStyleChange = function (params) {
        return this.bi.log(__assign({ evid: 33 }, params));
    };
    /**
    * @typedef {Object} templatesOpenEditorParams
    * @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
    * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
    * @property {string} book - null
    * @property {string} category - the create page category
    * @property {string} colors - list of selected colors
    * @property {GUID} esi - null
    * @property {string} features - list of selected features
    * @property {number} index - null
    * @property {number} galleryDocIndex - null
    * @property {number} gallerydocsperpage - null
    * @property {boolean} btn - null
    * @property {boolean} is_search_result - Is result from suggestion ("like you")
    * @property {string} layouts - list of selected layouts
    * @property {GUID} metasiteid - null
    * @property {Url} openingBrowserUrl - null
    * @property {string} origin - origin  page of edit template click
    * @property {Url} originappurl - only html template viewer send this property
    * @property {number} screen_height - Height of client device screen
    * @property {string} screen_type - the type of page in which the action was performed: category / search_results / main / home
    * @property {number} screen_width - Width of client device screen
    * @property {GUID} search_guid - If from search results, GUID of matching search
    * @property {number} search_rank - External ("like you") suggestion ranking
    * @property {number} siteType - 1=flash, 2=html, 3=mobile, 4=facebook html, 5 = facebook flash, 6=blog(old)
    * @property {string} sorting - selected sorting
    * @property {string} styles - list of selected styles
    * @property {string} sub_category - List of subcategory filters
    * @property {GUID} template_id - null
    * @property {GUID} openingSiteID - null
    * @property {string} template_type - ADI template or Editor template
    * @property {number} total_search_results - total search results from external ("like you") search suggestion
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    * @property {boolean} videoThumbnail - template shows a video when hovering on the thumbnail (TRUE/FALSE)
    * @property {number} window_height - Initial height of client window
    * @property {number} window_width - Initial width of client window
    * @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
    **/
    /**
     * Name: templates -> open editor. Evid: 15.
    
    
     * avail_height - Type: numeric. Desc: Returns the amount of vertical space in pixels available to the window
     *
     * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
     *
     * book - Type: string.
     *
     * category - Type: string. Desc: the create page category
     *
     * colors - Type: string. Desc: list of selected colors
     *
     * esi - Type: guid.
     *
     * features - Type: string. Desc: list of selected features
     *
     * index - Type: numeric.
     *
     * galleryDocIndex - Type: numeric.
     *
     * gallerydocsperpage - Type: numeric.
     *
     * btn - Type: bool.
     *
     * is_search_result - Type: bool. Desc: Is result from suggestion ("like you")
     *
     * layouts - Type: string. Desc: list of selected layouts
     *
     * metasiteid - Type: guid.
     *
     * openingBrowserUrl - Type: url.
     *
     * origin - Type: string. Desc: origin  page of edit template click
     *
     * originappurl - Type: url_with_parameters. Desc: only html template viewer send this property
     *
     * screen_height - Type: numeric. Desc: Height of client device screen
     *
     * screen_type - Type: string. Desc: the type of page in which the action was performed: category / search_results / main / home
     *
     * screen_width - Type: numeric. Desc: Width of client device screen
     *
     * search_guid - Type: guid. Desc: If from search results, GUID of matching search
     *
     * search_rank - Type: numeric. Desc: External ("like you") suggestion ranking
     *
     * siteType - Type: numeric. Desc: 1=flash, 2=html, 3=mobile, 4=facebook html, 5 = facebook flash, 6=blog(old)
     *
     * sorting - Type: string. Desc: selected sorting
     *
     * styles - Type: string. Desc: list of selected styles
     *
     * sub_category - Type: string. Desc: List of subcategory filters
     *
     * template_id - Type: guid.
     *
     * openingSiteID - Type: guid.
     *
     * template_type - Type: string. Desc: ADI template or Editor template
     *
     * total_search_results - Type: numeric. Desc: total search results from external ("like you") search suggestion
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     *
     * videoThumbnail - Type: bool. Desc: template shows a video when hovering on the thumbnail (TRUE/FALSE)
     *
     * window_height - Type: numeric. Desc: Initial height of client window
     *
     * window_width - Type: numeric. Desc: Initial width of client window
     *
     * wixsession - Type: string. Desc: authentication token. if the session exists, then the user is logged in.
     * @param {templatesOpenEditorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesOpenEditor = function (params) {
        return this.bi.log(__assign({ evid: 15 }, params));
    };
    /**
    * @typedef {Object} flashLoginSignupErrorPasswordIsNotValidParams
    * @property {GUID} siteid - null
    **/
    /**
     * Name: (flash login) signup error (password is not valid). Evid: 6.
    
    
     * siteid - Type: guid.
     * @param {flashLoginSignupErrorPasswordIsNotValidParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.flashLoginSignupErrorPasswordIsNotValid = function (params) {
        return this.bi.log(__assign({ evid: 6 }, params));
    };
    /**
    * @typedef {Object} templateMixerTabChangeParams
    * @property {string} tab_name - null
    * @property {GUID} template_id - null
    **/
    /**
     * Name: template mixer -> tab change. Evid: 31.
    
    
     * tab_name - Type: string.
     *
     * template_id - Type: guid.
     * @param {templateMixerTabChangeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templateMixerTabChange = function (params) {
        return this.bi.log(__assign({ evid: 31 }, params));
    };
    /**
    * @typedef {Object} templatesCloseVideoPreviewParams
    * @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
    * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
    * @property {string} book - book
    * @property {string} category - the create page category
    * @property {string} colors - list of selected colors
    * @property {string} features - list of selected features
    * @property {number} gallerydocsperpage - gallery docs per page
    * @property {boolean} is_search_result - Is result from suggestion ("like you")
    * @property {string} layouts - list of selected layouts
    * @property {number} screen_height - Height of client device screen
    * @property {string} screen_type - the type of page in which the action was performed: category / search_results / main / home
    * @property {number} screen_width - Width of client device screen
    * @property {GUID} search_guid - (optional) If from search results, GUID of matching search
    * @property {number} search_rank - External ("like you") suggestion ranking
    * @property {string} sorting - selected sorting
    * @property {string} styles - list of selected styles
    * @property {string} sub_category - List of subcategory filters
    * @property {GUID} openingSiteID - template_id
    * @property {number} total_search_results - total search results from external ("like you") search suggestion
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    * @property {DateTime} video_end_time - video end time
    * @property {number} video_full_duration - null
    * @property {number} video_playback_position - null
    * @property {DateTime} video_start_time - video start time
    * @property {string} video_status - 'have_nothing', 'have_metadata', 'have_current_data', 'have_future_data', 'have_enough_data'
    * @property {number} window_height - Initial height of client window
    * @property {number} window_width - Initial width of client window
    **/
    /**
     * Name: templates -> close video preview. Evid: 69.
     * Event description: user clicked on 'x' to close the video preview pop up or just moved out of the thumbnail.
    
     * avail_height - Type: numeric. Desc: Returns the amount of vertical space in pixels available to the window
     *
     * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
     *
     * book - Type: string. Desc: book
     *
     * category - Type: string. Desc: the create page category
     *
     * colors - Type: string. Desc: list of selected colors
     *
     * features - Type: string. Desc: list of selected features
     *
     * gallerydocsperpage - Type: numeric. Desc: gallery docs per page
     *
     * is_search_result - Type: bool. Desc: Is result from suggestion ("like you")
     *
     * layouts - Type: string. Desc: list of selected layouts
     *
     * screen_height - Type: numeric. Desc: Height of client device screen
     *
     * screen_type - Type: string. Desc: the type of page in which the action was performed: category / search_results / main / home
     *
     * screen_width - Type: numeric. Desc: Width of client device screen
     *
     * search_guid - Type: guid. Desc: (optional) If from search results, GUID of matching search
     *
     * search_rank - Type: numeric. Desc: External ("like you") suggestion ranking
     *
     * sorting - Type: string. Desc: selected sorting
     *
     * styles - Type: string. Desc: list of selected styles
     *
     * sub_category - Type: string. Desc: List of subcategory filters
     *
     * openingSiteID - Type: guid. Desc: template_id
     *
     * total_search_results - Type: numeric. Desc: total search results from external ("like you") search suggestion
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     *
     * video_end_time - Type: datetime. Desc: video end time
     *
     * video_full_duration - Type: numeric.
     *
     * video_playback_position - Type: numeric.
     *
     * video_start_time - Type: datetime. Desc: video start time
     *
     * video_status - Type: string. Desc: 'have_nothing', 'have_metadata', 'have_current_data', 'have_future_data', 'have_enough_data'
     *
     * window_height - Type: numeric. Desc: Initial height of client window
     *
     * window_width - Type: numeric. Desc: Initial width of client window
     * @param {templatesCloseVideoPreviewParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesCloseVideoPreview = function (params) {
        return this.bi.log(__assign({ evid: 69 }, params));
    };
    /**
    * @typedef {Object} oldMyAccountPopupBlockedTheEditorParams
    * @property {Url} app - null
    * @property {undefined} docid - null
    * @property {Url} openingbrowserurl - null
    * @property {GUID} siteid - null
    * @property {string} openingSiteID - null
    **/
    /**
     * Name: (old my account) popup blocked the editor. Evid: 9.
    
    
     * app - Type: url.
     *
     * docid - Type: obsolete_docid.
     *
     * openingbrowserurl - Type: url.
     *
     * siteid - Type: guid.
     *
     * openingSiteID - Type: string.
     * @param {oldMyAccountPopupBlockedTheEditorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oldMyAccountPopupBlockedTheEditor = function (params) {
        return this.bi.log(__assign({ evid: 9 }, params));
    };
    /**
    * @typedef {Object} postRegPageClickHereLinkParams
    
    **/
    /**
     * Name: post reg page -> click here link. Evid: 29.
    
    
    
     * @param {postRegPageClickHereLinkParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postRegPageClickHereLink = function (params) {
        return this.bi.log(__assign({ evid: 29 }, params));
    };
    /**
    * @typedef {Object} templatesFullLoadingTimesParams
    * @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
    * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
    * @property {number} basic_loading_time - basic_loading_time
    * @property {number} connect_end - connect_end
    * @property {number} connect_start - connect_start
    * @property {number} domComplete_ts - domComplete_ts
    * @property {number} dom_content_loaded_event_end - dom_content_loaded_event_end
    * @property {number} dom_content_loaded_event_start - dom_content_loaded_event_start
    * @property {number} dom_interactive - dom_interactive
    * @property {number} domLoading_ts - dom_loading_ts
    * @property {number} domain_lookup_end - domain_lookup_end
    * @property {number} domain_lookup_start - domain_lookup_start
    * @property {number} fetch_start - fetch_start
    * @property {number} load_event_end - load_event_end
    * @property {number} load_event_start - load_event_start
    * @property {number} navigation_start - navigation_start
    * @property {number} redirect_end - redirect_end
    * @property {number} redirect_start - redirect_start
    * @property {number} request_start - request_start
    * @property {number} response_end - response_end
    * @property {number} response_start - response_start
    * @property {number} screen_height - Height of client device screen
    * @property {number} screen_width - Width of client device screen
    * @property {number} secure_connection_start - secure_connection_start
    * @property {GUID} tpsi - Templates Page Session ID
    * @property {number} unload_event_end - unload_event_end
    * @property {number} unload_event_start - unload_event_start
    * @property {number} window_height - Initial height of client window
    * @property {number} window_width - Initial width of client window
    **/
    /**
     * Name: templates -> templates page loaded. Evid: 49.
     * Event description: full loading times for templates page.
    
     * avail_height - Type: numeric. Desc: Returns the amount of vertical space in pixels available to the window
     *
     * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
     *
     * basic_loading_time - Type: numeric. Desc: basic_loading_time
     *
     * connect_end - Type: numeric. Desc: connect_end
     *
     * connect_start - Type: numeric. Desc: connect_start
     *
     * domComplete_ts - Type: numeric. Desc: domComplete_ts
     *
     * dom_content_loaded_event_end - Type: numeric. Desc: dom_content_loaded_event_end
     *
     * dom_content_loaded_event_start - Type: numeric. Desc: dom_content_loaded_event_start
     *
     * dom_interactive - Type: numeric. Desc: dom_interactive
     *
     * domLoading_ts - Type: numeric. Desc: dom_loading_ts
     *
     * domain_lookup_end - Type: numeric. Desc: domain_lookup_end
     *
     * domain_lookup_start - Type: numeric. Desc: domain_lookup_start
     *
     * fetch_start - Type: numeric. Desc: fetch_start
     *
     * load_event_end - Type: numeric. Desc: load_event_end
     *
     * load_event_start - Type: numeric. Desc: load_event_start
     *
     * navigation_start - Type: numeric. Desc: navigation_start
     *
     * redirect_end - Type: numeric. Desc: redirect_end
     *
     * redirect_start - Type: numeric. Desc: redirect_start
     *
     * request_start - Type: numeric. Desc: request_start
     *
     * response_end - Type: numeric. Desc: response_end
     *
     * response_start - Type: numeric. Desc: response_start
     *
     * screen_height - Type: numeric. Desc: Height of client device screen
     *
     * screen_width - Type: numeric. Desc: Width of client device screen
     *
     * secure_connection_start - Type: numeric. Desc: secure_connection_start
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID
     *
     * unload_event_end - Type: numeric. Desc: unload_event_end
     *
     * unload_event_start - Type: numeric. Desc: unload_event_start
     *
     * window_height - Type: numeric. Desc: Initial height of client window
     *
     * window_width - Type: numeric. Desc: Initial width of client window
     * @param {templatesFullLoadingTimesParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesFullLoadingTimes = function (params) {
        return this.bi.log(__assign({ evid: 49 }, params));
    };
    /**
    * @typedef {Object} templatesPagePerformanceTimingClientParams
    * @property {string} context_param - (Optional) Additional info related to segment
    * @property {string} segment_name - Segment name
    * @property {number} time - Time taken to execute segment
    **/
    /**
     * Name: Templates Page -> Performance Timing (client). Evid: 53.
     * Event description: Performance timing of segments.
    
     * context_param - Type: string. Desc: (Optional) Additional info related to segment
     *
     * segment_name - Type: string. Desc: Segment name
     *
     * time - Type: numeric. Desc: Time taken to execute segment
     * @param {templatesPagePerformanceTimingClientParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesPagePerformanceTimingClient = function (params) {
        return this.bi.log(__assign({ evid: 53 }, params));
    };
    /**
    * @typedef {Object} clickOnThumbnailParams
    * @property {string} book - book
    * @property {number} gallerydocindex - gallery doc index of the template
    * @property {number} galleryDocsPerPage - number of templates in the page
    * @property {Url} openingbrowserurl - null
    * @property {string} origin - origin page
    * @property {number} siteType - site type
    * @property {GUID} template_id - template guid of the thumbnail
    * @property {string} openingSiteID - null
    **/
    /**
     * Name: click on thumbnail. Evid: 32.
     * Event description: client event fired when clicking on thumbnail space - everywhere except the buttons..
    
     * book - Type: string. Desc: book
     *
     * gallerydocindex - Type: numeric. Desc: gallery doc index of the template
     *
     * galleryDocsPerPage - Type: numeric. Desc: number of templates in the page
     *
     * openingbrowserurl - Type: url.
     *
     * origin - Type: string. Desc: origin page
     *
     * siteType - Type: numeric. Desc: site type
     *
     * template_id - Type: guid. Desc: template guid of the thumbnail
     *
     * openingSiteID - Type: string.
     * @param {clickOnThumbnailParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnThumbnail = function (params) {
        return this.bi.log(__assign({ evid: 32 }, params));
    };
    /**
    * @typedef {Object} homePageClickOnTemplateParams
    * @property {GUID} context - null
    **/
    /**
     * Name: home page -> click on template. Evid: 21.
    
    
     * context - Type: guid.
     * @param {homePageClickOnTemplateParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.homePageClickOnTemplate = function (params) {
        return this.bi.log(__assign({ evid: 21 }, params));
    };
    /**
    * @typedef {Object} templatesWidgetAboveTheFoldImpressionParams
    * @property {number} avail_height - Returns the amount of horizontal space in pixels vertical to the window
    * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
    * @property {string} book - book
    * @property {string} category - Main category name
    * @property {number} screen_height - Height of client device screen
    * @property {number} screen_width - Width of client device screen
    * @property {string} sub_category - List of subcategory filters
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    * @property {string} widget_name - The vertical presented in the Widget (Blog, Online Store, etc.)
    * @property {number} window_height - Initial height of client window
    * @property {number} window_width - Initial width of client window
    **/
    /**
     * Name: templates -> Widget Above the Fold Impression. Evid: 61.
     * Event description: When a user has the Templates Page widget above the fold.
    
     * avail_height - Type: numeric. Desc: Returns the amount of horizontal space in pixels vertical to the window
     *
     * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
     *
     * book - Type: string. Desc: book
     *
     * category - Type: string. Desc: Main category name
     *
     * screen_height - Type: numeric. Desc: Height of client device screen
     *
     * screen_width - Type: numeric. Desc: Width of client device screen
     *
     * sub_category - Type: string. Desc: List of subcategory filters
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     *
     * widget_name - Type: string. Desc: The vertical presented in the Widget (Blog, Online Store, etc.)
     *
     * window_height - Type: numeric. Desc: Initial height of client window
     *
     * window_width - Type: numeric. Desc: Initial width of client window
     * @param {templatesWidgetAboveTheFoldImpressionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesWidgetAboveTheFoldImpression = function (params) {
        return this.bi.log(__assign({ evid: 61 }, params));
    };
    /**
    * @typedef {Object} templatesViewTemplateParams
    * @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
    * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
    * @property {string} book - null
    * @property {string} category - the create page category
    * @property {string} colors - list of selected colors
    * @property {string} features - list of selected features
    * @property {number} index - null
    * @property {number} galleryDocIndex - null
    * @property {number} gallerydocsperpage - null
    * @property {boolean} btn - null
    * @property {boolean} is_search_result - Is result from suggestion ("like you")
    * @property {string} layouts - list of selected layouts
    * @property {Url} openingBrowserUrl - null
    * @property {Url} openingbrowserurl - null
    * @property {string} origin - null
    * @property {string} product - null
    * @property {number} screen_height - Height of client device screen
    * @property {string} screen_type - the type of page in which the action was performed: category / search_results / main / home
    * @property {number} screen_width - Width of client device screen
    * @property {GUID} search_guid - (optional) If from search results, GUID of matching search
    * @property {number} search_rank - External ("like you") suggestion ranking
    * @property {number} siteType - null
    * @property {string} sorting - selected sorting
    * @property {string} styles - list of selected styles
    * @property {string} sub_category - List of subcategory filters
    * @property {GUID} openingSiteID - null
    * @property {number} total_search_results - total search results from external ("like you") search suggestion
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    * @property {boolean} videoThumbnail - template shows a video when hovering on the thumbnail (TRUE/FALSE)
    * @property {number} window_height - Initial height of client window
    * @property {number} window_width - Initial width of client window
    **/
    /**
     * Name: templates -> view template. Evid: 14.
    
    
     * avail_height - Type: numeric. Desc: Returns the amount of vertical space in pixels available to the window
     *
     * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
     *
     * book - Type: string.
     *
     * category - Type: string. Desc: the create page category
     *
     * colors - Type: string. Desc: list of selected colors
     *
     * features - Type: string. Desc: list of selected features
     *
     * index - Type: numeric.
     *
     * galleryDocIndex - Type: numeric.
     *
     * gallerydocsperpage - Type: numeric.
     *
     * btn - Type: bool.
     *
     * is_search_result - Type: bool. Desc: Is result from suggestion ("like you")
     *
     * layouts - Type: string. Desc: list of selected layouts
     *
     * openingBrowserUrl - Type: url.
     *
     * openingbrowserurl - Type: url.
     *
     * origin - Type: string.
     *
     * product - Type: string.
     *
     * screen_height - Type: numeric. Desc: Height of client device screen
     *
     * screen_type - Type: string. Desc: the type of page in which the action was performed: category / search_results / main / home
     *
     * screen_width - Type: numeric. Desc: Width of client device screen
     *
     * search_guid - Type: guid. Desc: (optional) If from search results, GUID of matching search
     *
     * search_rank - Type: numeric. Desc: External ("like you") suggestion ranking
     *
     * siteType - Type: numeric.
     *
     * sorting - Type: string. Desc: selected sorting
     *
     * styles - Type: string. Desc: list of selected styles
     *
     * sub_category - Type: string. Desc: List of subcategory filters
     *
     * openingSiteID - Type: guid.
     *
     * total_search_results - Type: numeric. Desc: total search results from external ("like you") search suggestion
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     *
     * videoThumbnail - Type: bool. Desc: template shows a video when hovering on the thumbnail (TRUE/FALSE)
     *
     * window_height - Type: numeric. Desc: Initial height of client window
     *
     * window_width - Type: numeric. Desc: Initial width of client window
     * @param {templatesViewTemplateParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesViewTemplate = function (params) {
        return this.bi.log(__assign({ evid: 14 }, params));
    };
    /**
    * @typedef {Object} templatesFinishedLoadingThePageParams
    * @property {string} book - null
    * @property {string} category - the create page category
    * @property {string} colors - list of selected colors
    * @property {string} event_data - json with template list: returns all templates in the page loaded and their locations
    * @property {string} features - list of selected features
    * @property {number} galleryDocsPerPage - null
    * @property {Url} http_referrer - null
    * @property {string} interaction_type - Type of templates page interaction
    * @property {string} layouts - list of selected layouts
    * @property {number} loadingTime - time to load the page
    * @property {string} origin - origin page
    * @property {number} page_index - the category index of the template
    * @property {string} platform - null
    * @property {string} product - create page product filter
    * @property {string} sorting - selected sorting
    * @property {string} styles - list of selected styles
    * @property {string} sub_category - List of subcategory filters
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    **/
    /**
     * Name: templates -> finished loading the page. Evid: 23.
    
    
     * book - Type: string.
     *
     * category - Type: string. Desc: the create page category
     *
     * colors - Type: string. Desc: list of selected colors
     *
     * event_data - Type: string. Desc: json with template list: returns all templates in the page loaded and their locations
     *
     * features - Type: string. Desc: list of selected features
     *
     * galleryDocsPerPage - Type: numeric.
     *
     * http_referrer - Type: url_with_parameters.
     *
     * interaction_type - Type: string. Desc: Type of templates page interaction
     *
     * layouts - Type: string. Desc: list of selected layouts
     *
     * loadingTime - Type: numeric. Desc: time to load the page
     *
     * origin - Type: string. Desc: origin page
     *
     * page_index - Type: numeric. Desc: the category index of the template
     *
     * platform - Type: string.
     *
     * product - Type: string. Desc: create page product filter
     *
     * sorting - Type: string. Desc: selected sorting
     *
     * styles - Type: string. Desc: list of selected styles
     *
     * sub_category - Type: string. Desc: List of subcategory filters
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     * @param {templatesFinishedLoadingThePageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesFinishedLoadingThePage = function (params) {
        return this.bi.log(__assign({ evid: 23 }, params));
    };
    /**
    * @typedef {Object} oldMyAccountTryToOpenViewerFromMyAccountAbusedEventParams
    
    **/
    /**
     * Name: (old my account) try to open viewer from my account (abused event). Evid: 7.
    
    
    
     * @param {oldMyAccountTryToOpenViewerFromMyAccountAbusedEventParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.oldMyAccountTryToOpenViewerFromMyAccountAbusedEvent = function (params) {
        return this.bi.log(__assign({ evid: 7 }, params));
    };
    /**
    * @typedef {Object} copyOfTemplatesSwitchToTabletParams
    * @property {string} category - the create page category
    * @property {Url} originappurl - only html template viewer send this property
    * @property {number} siteType - site type
    * @property {GUID} openingSiteID - template id
    **/
    /**
     * Name: Copy of templates -> switch to tablet. Evid: 98.
     * Event description: user switched to tablet view.
    
     * category - Type: string. Desc: the create page category
     *
     * originappurl - Type: url_with_parameters. Desc: only html template viewer send this property
     *
     * siteType - Type: numeric. Desc: site type
     *
     * openingSiteID - Type: guid. Desc: template id
     * @param {copyOfTemplatesSwitchToTabletParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.copyOfTemplatesSwitchToTablet = function (params) {
        return this.bi.log(__assign({ evid: 98 }, params));
    };
    /**
    * @typedef {Object} templatesJavascriptLoadedParams
    * @property {string} book - null
    * @property {string} category - null
    * @property {string} event_data - null
    * @property {number} galleryDocsPerPage - null
    * @property {Url} http_referrer - null
    * @property {number} loadingTime - null
    * @property {string} origin - null
    * @property {number} page_index - null
    * @property {string} platform - null
    * @property {string} product - null
    **/
    /**
     * Name: templates -> javascript loaded. Evid: 47.
     * Event description: templates page javascript and functionality loaded and ready.
    
     * book - Type: string.
     *
     * category - Type: string.
     *
     * event_data - Type: string.
     *
     * galleryDocsPerPage - Type: numeric.
     *
     * http_referrer - Type: url_with_parameters.
     *
     * loadingTime - Type: numeric.
     *
     * origin - Type: string.
     *
     * page_index - Type: numeric.
     *
     * platform - Type: string.
     *
     * product - Type: string.
     * @param {templatesJavascriptLoadedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesJavascriptLoaded = function (params) {
        return this.bi.log(__assign({ evid: 47 }, params));
    };
    /**
    * @typedef {Object} templatesClickOnElementParams
    * @property {string} book - book name
    * @property {string} category - the create page category
    * @property {string} clicked_element - the element that was clicked
    * @property {string} clicked_element_identifier - category name for categories and template_guid for templates
    * @property {number} galleryDocIndex - gallery_doc_index
    * @property {number} gallerydocsperpage - gallerydocsperpage
    * @property {Url} openingBrowserUrl - opening_browser_url
    * @property {Url} originappurl - only html template viewer send this property
    * @property {string} screen_type - the type of page in which the action was performed: category / search_results / main / home
    * @property {number} siteType - 1=flash, 2=html, 3=mobile, 4=facebook html, 5 = facebook flash, 6=blog(old)
    * @property {string} sub_category - Sub category clicked from
    * @property {GUID} template_id - in case of click on template thumbnail
    * @property {string} template_type - ADI template or Editor template
    * @property {GUID} tpsi - Templates Page Session ID
    * @property {boolean} videoThumbnail - template shows a video when hovering on the thumbnail (TRUE/FALSE)
    * @property {string} wixsession - authentication token. if the session exists, then the user is logged in.
    **/
    /**
     * Name: templates -> click on element. Evid: 48.
     * Event description: templates -> click on element.
    
     * book - Type: string. Desc: book name
     *
     * category - Type: string. Desc: the create page category
     *
     * clicked_element - Type: string. Desc: the element that was clicked
     *
     * clicked_element_identifier - Type: string. Desc: category name for categories and template_guid for templates
     *
     * galleryDocIndex - Type: numeric. Desc: gallery_doc_index
     *
     * gallerydocsperpage - Type: numeric. Desc: gallerydocsperpage
     *
     * openingBrowserUrl - Type: url. Desc: opening_browser_url
     *
     * originappurl - Type: url_with_parameters. Desc: only html template viewer send this property
     *
     * screen_type - Type: string. Desc: the type of page in which the action was performed: category / search_results / main / home
     *
     * siteType - Type: numeric. Desc: 1=flash, 2=html, 3=mobile, 4=facebook html, 5 = facebook flash, 6=blog(old)
     *
     * sub_category - Type: string. Desc: Sub category clicked from
     *
     * template_id - Type: guid. Desc: in case of click on template thumbnail
     *
     * template_type - Type: string. Desc: ADI template or Editor template
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID
     *
     * videoThumbnail - Type: bool. Desc: template shows a video when hovering on the thumbnail (TRUE/FALSE)
     *
     * wixsession - Type: string. Desc: authentication token. if the session exists, then the user is logged in.
     * @param {templatesClickOnElementParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesClickOnElement = function (params) {
        return this.bi.log(__assign({ evid: 48 }, params));
    };
    /**
    * @typedef {Object} templatesStartedLoadingThePageParams
    * @property {string} book - null
    * @property {string} category - the create page category
    * @property {string} colors - list of selected colors
    * @property {string} event_data - data about templates loaded
    * @property {string} features - list of selected features
    * @property {number} galleryDocsPerPage - null
    * @property {Url} http_referrer - null
    * @property {string} interaction_type - Type of templates page interaction
    * @property {string} layouts - list of selected layouts
    * @property {string} origin - origin page
    * @property {number} page_index - the category index of the template
    * @property {string} platform - null
    * @property {string} product - create page product filter
    * @property {string} referralInfo - -
    * @property {string} sorting - selected sorting
    * @property {string} styles - list of selected styles
    * @property {string} sub_category - List of subcategory filters
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    **/
    /**
     * Name: templates -> started loading the page. Evid: 22.
    
    
     * book - Type: string.
     *
     * category - Type: string. Desc: the create page category
     *
     * colors - Type: string. Desc: list of selected colors
     *
     * event_data - Type: string. Desc: data about templates loaded
     *
     * features - Type: string. Desc: list of selected features
     *
     * galleryDocsPerPage - Type: numeric.
     *
     * http_referrer - Type: url_with_parameters.
     *
     * interaction_type - Type: string. Desc: Type of templates page interaction
     *
     * layouts - Type: string. Desc: list of selected layouts
     *
     * origin - Type: string. Desc: origin page
     *
     * page_index - Type: numeric. Desc: the category index of the template
     *
     * platform - Type: string.
     *
     * product - Type: string. Desc: create page product filter
     *
     * referralInfo - Type: string. Desc: -
     *
     * sorting - Type: string. Desc: selected sorting
     *
     * styles - Type: string. Desc: list of selected styles
     *
     * sub_category - Type: string. Desc: List of subcategory filters
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     * @param {templatesStartedLoadingThePageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesStartedLoadingThePage = function (params) {
        return this.bi.log(__assign({ evid: 22 }, params));
    };
    /**
    * @typedef {Object} templatesTemplateAboveTheFoldImpressionParams
    * @property {number} avail_height - Returns the amount of horizontal space in pixels vertical to the window
    * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
    * @property {string} book - book
    * @property {string} category - category
    * @property {string} colors - list of selected colors
    * @property {string} features - list of selected features
    * @property {number} galleryDocIndex - gallery doc index
    * @property {number} galleryDocsPerPage - gallery doc page
    * @property {string} layouts - list of selected layouts
    * @property {number} page_view_index - Page Index
    * @property {number} screen_height - Height of client device screen
    * @property {number} screen_width - Width of client device screen
    * @property {number} siteType - site type
    * @property {string} sorting - selected sorting
    * @property {string} styles - list of selected styles
    * @property {string} sub_category - List of subcategory filters
    * @property {GUID} template_id - template guid
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    * @property {number} window_height - Initial height of client window
    * @property {number} window_width - Initial width of client window
    **/
    /**
     * Name: templates -> Template Above the Fold Impression. Evid: 52.
     * Event description: When a user has a template above the fold on the Templates Page or clicks any component on the thumbnail.
    
     * avail_height - Type: numeric. Desc: Returns the amount of horizontal space in pixels vertical to the window
     *
     * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
     *
     * book - Type: string. Desc: book
     *
     * category - Type: string. Desc: category
     *
     * colors - Type: string. Desc: list of selected colors
     *
     * features - Type: string. Desc: list of selected features
     *
     * galleryDocIndex - Type: numeric. Desc: gallery doc index
     *
     * galleryDocsPerPage - Type: numeric. Desc: gallery doc page
     *
     * layouts - Type: string. Desc: list of selected layouts
     *
     * page_view_index - Type: numeric. Desc: Page Index
     *
     * screen_height - Type: numeric. Desc: Height of client device screen
     *
     * screen_width - Type: numeric. Desc: Width of client device screen
     *
     * siteType - Type: numeric. Desc: site type
     *
     * sorting - Type: string. Desc: selected sorting
     *
     * styles - Type: string. Desc: list of selected styles
     *
     * sub_category - Type: string. Desc: List of subcategory filters
     *
     * template_id - Type: guid. Desc: template guid
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     *
     * window_height - Type: numeric. Desc: Initial height of client window
     *
     * window_width - Type: numeric. Desc: Initial width of client window
     * @param {templatesTemplateAboveTheFoldImpressionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesTemplateAboveTheFoldImpression = function (params) {
        return this.bi.log(__assign({ evid: 52 }, params));
    };
    /**
    * @typedef {Object} landingPageViewTemplateParams
    * @property {number} galleryDocIndex - a zero-based index of the template on the page
    * @property {number} gallerydocsperpage - null
    * @property {string} landing_url - null
    * @property {Url} openingbrowserurl - null
    * @property {number} page_index - the category index of the template
    * @property {number} siteType - null
    * @property {GUID} openingSiteID - null
    **/
    /**
     * Name: landing page > view template. Evid: 16.
    
    
     * galleryDocIndex - Type: numeric. Desc: a zero-based index of the template on the page
     *
     * gallerydocsperpage - Type: numeric.
     *
     * landing_url - Type: string.
     *
     * openingbrowserurl - Type: url.
     *
     * page_index - Type: numeric. Desc: the category index of the template
     *
     * siteType - Type: numeric.
     *
     * openingSiteID - Type: guid.
     * @param {landingPageViewTemplateParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.landingPageViewTemplate = function (params) {
        return this.bi.log(__assign({ evid: 16 }, params));
    };
    /**
    * @typedef {Object} flashLoginSignupFormIsOpenedTestParams
    * @property {string} eventData - test
    * @property {GUID} msid - test
    * @property {string} origin - test
    * @property {GUID} siteid - null
    * @property {string} template - delete me
    * @property {string} template_name - delete me
    **/
    /**
     * Name: (flash login) signup form is opened. Evid: 3.
    
    
     * eventData - Type: string. Desc: test
     *
     * msid - Type: guid. Desc: test
     *
     * origin - Type: string. Desc: test
     *
     * siteid - Type: guid.
     *
     * template - Type: string. Desc: delete me
     *
     * template_name - Type: string. Desc: delete me
     * @param {flashLoginSignupFormIsOpenedTestParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.flashLoginSignupFormIsOpenedTest = function (params) {
        return this.bi.log(__assign({ evid: 3 }, params));
    };
    /**
    * @typedef {Object} timeoutParams
    
    **/
    /**
     * Name: timeout. Evid: 20.
    
    
    
     * @param {timeoutParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.timeout = function (params) {
        return this.bi.log(__assign({ evid: 20 }, params));
    };
    /**
    * @typedef {Object} templatesPageWebVitalsMetricsParams
    * @property {number} delta - The delta between the current value and the last-reported value. On the first report, `delta` and `value` will always be the same.
    * @property {string} id - A unique ID representing this particular metric that's specific to the current page. This ID can be used by an analytics tool to dedupe multiple values sent for the same metric, or to group multiple deltas together and calculate a total
    * @property {boolean} is_final - `false` if the value of the metric may change in the future, for the current page
    * @property {string} metric_name - The name of the metric (in acronym form: 'CLS' | 'FCP' | 'FID' | 'LCP' | 'TTFB')
    * @property {number} metric_value - The current value of the metric
    **/
    /**
     * Name: templates -> page web vitals metrics. Evid: 100.
     * Event description: Measures of page performance.
    
     * delta - Type: numeric. Desc: The delta between the current value and the last-reported value. On the first report, `delta` and `value` will always be the same.
     *
     * id - Type: string. Desc: A unique ID representing this particular metric that's specific to the current page. This ID can be used by an analytics tool to dedupe multiple values sent for the same metric, or to group multiple deltas together and calculate a total
     *
     * is_final - Type: bool. Desc: `false` if the value of the metric may change in the future, for the current page
     *
     * metric_name - Type: string. Desc: The name of the metric (in acronym form: 'CLS' | 'FCP' | 'FID' | 'LCP' | 'TTFB')
     *
     * metric_value - Type: numeric. Desc: The current value of the metric
     * @param {templatesPageWebVitalsMetricsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesPageWebVitalsMetrics = function (params) {
        return this.bi.log(__assign({ evid: 100 }, params));
    };
    /**
    * @typedef {Object} templatesSeeAllTemplatesParams
    * @property {string} from_category - templates page origin category
    * @property {Url} originappurl - only html template viewer send this property
    * @property {string} template_id - template guid
    * @property {string} to_category - templates page target category
    **/
    /**
     * Name: templates -> see all templates. Evid: 46.
     * Event description: When a user clicks on "see all templates" from the viewer
    https://jira.wixpress.com/browse/MRND-2219.
    
     * from_category - Type: string. Desc: templates page origin category
     *
     * originappurl - Type: url_with_parameters. Desc: only html template viewer send this property
     *
     * template_id - Type: string. Desc: template guid
     *
     * to_category - Type: string. Desc: templates page target category
     * @param {templatesSeeAllTemplatesParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesSeeAllTemplates = function (params) {
        return this.bi.log(__assign({ evid: 46 }, params));
    };
    /**
    * @typedef {Object} flashEditorAddBlogComponentParams
    
    **/
    /**
     * Name: (flash editor) add blog component. Evid: 59.
    
    
    
     * @param {flashEditorAddBlogComponentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.flashEditorAddBlogComponent = function (params) {
        return this.bi.log(__assign({ evid: 59 }, params));
    };
    /**
    * @typedef {Object} postRegPageClickOnGoParams
    * @property {string} cat - null
    * @property {string} industryId - industry_id
    * @property {string} location - Top, Bottom, Left etc' - Used in case of multiple buttons with the same name
    * @property {string} sourceScreen - new/vertical or new/intro or second/intro
    * @property {string} structureId - structure_id
    * @property {string} subcat - null
    **/
    /**
     * Name: post reg page -> click on GO. Evid: 30.
    
    
     * cat - Type: string.
     *
     * industryId - Type: string. Desc: industry_id
     *
     * location - Type: string. Desc: Top, Bottom, Left etc' - Used in case of multiple buttons with the same name
     *
     * sourceScreen - Type: string. Desc: new/vertical or new/intro or second/intro
     *
     * structureId - Type: string. Desc: structure_id
     *
     * subcat - Type: string.
     * @param {postRegPageClickOnGoParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.postRegPageClickOnGo = function (params) {
        return this.bi.log(__assign({ evid: 30 }, params));
    };
    /**
    * @typedef {Object} templatesSearchParams
    * @property {string} book - null
    * @property {string} click_source - Main Header/Sticky Header
    * @property {string} colors - list of selected colors
    * @property {string} criteria - null
    * @property {number} currentPage - null
    * @property {string} features - list of selected features
    * @property {string} layouts - list of selected layouts
    * @property {string} previous_category - category in which the search was performed
    * @property {string} previous_sub_category - a sub category in which the search was performed
    * @property {GUID} search_guid - Unique GUID of search
    * @property {string} sorting - selected sorting
    * @property {string} source - the source of the search query
    * @property {string} styles - list of selected styles
    * @property {number} numberOfTemplatesInCurrentPage - null
    * @property {number} totalPages - null
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    **/
    /**
     * Name: templates -> search. Evid: 26.
    
    
     * book - Type: string.
     *
     * click_source - Type: string. Desc: Main Header/Sticky Header
     *
     * colors - Type: string. Desc: list of selected colors
     *
     * criteria - Type: string.
     *
     * currentPage - Type: numeric.
     *
     * features - Type: string. Desc: list of selected features
     *
     * layouts - Type: string. Desc: list of selected layouts
     *
     * previous_category - Type: string. Desc: category in which the search was performed
     *
     * previous_sub_category - Type: string. Desc: a sub category in which the search was performed
     *
     * search_guid - Type: guid. Desc: Unique GUID of search
     *
     * sorting - Type: string. Desc: selected sorting
     *
     * source - Type: string. Desc: the source of the search query
     *
     * styles - Type: string. Desc: list of selected styles
     *
     * numberOfTemplatesInCurrentPage - Type: numeric.
     *
     * totalPages - Type: numeric.
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     * @param {templatesSearchParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesSearch = function (params) {
        return this.bi.log(__assign({ evid: 26 }, params));
    };
    /**
    * @typedef {Object} testEventNameParams
    
    **/
    /**
     * Name: test event name. Evid: 63.
     * Event description: User engagement with the Templates Page widget.
    
    
     * @param {testEventNameParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.testEventName = function (params) {
        return this.bi.log(__assign({ evid: 63 }, params));
    };
    /**
    * @typedef {Object} templatesVideoPreviewOpenParams
    * @property {number} avail_height - Returns the amount of vertical space in pixels available to the window
    * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
    * @property {string} book - book
    * @property {string} category - the create page category
    * @property {string} colors - list of selected colors
    * @property {string} features - list of selected features
    * @property {number} gallerydocsperpage - gallery docs per page
    * @property {boolean} is_search_result - Is result from suggestion ("like you")
    * @property {string} layouts - list of selected layouts
    * @property {number} screen_height - Height of client device screen
    * @property {string} screen_type - the type of page in which the action was performed: category / search_results / main / home
    * @property {number} screen_width - Width of client device screen
    * @property {GUID} search_guid - (optional) If from search results, GUID of matching search
    * @property {number} search_rank - External ("like you") suggestion ranking
    * @property {string} sorting - selected sorting
    * @property {string} styles - list of selected styles
    * @property {string} sub_category - List of subcategory filters
    * @property {GUID} openingSiteID - template_id
    * @property {number} total_search_results - total search results from external ("like you") search suggestion
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    * @property {number} window_height - Initial height of client window
    * @property {number} window_width - Initial width of client window
    **/
    /**
     * Name: templates -> video preview open. Evid: 65.
     * Event description: user clicked on a thumbnail with a video which opened the preview pop up.
    
     * avail_height - Type: numeric. Desc: Returns the amount of vertical space in pixels available to the window
     *
     * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
     *
     * book - Type: string. Desc: book
     *
     * category - Type: string. Desc: the create page category
     *
     * colors - Type: string. Desc: list of selected colors
     *
     * features - Type: string. Desc: list of selected features
     *
     * gallerydocsperpage - Type: numeric. Desc: gallery docs per page
     *
     * is_search_result - Type: bool. Desc: Is result from suggestion ("like you")
     *
     * layouts - Type: string. Desc: list of selected layouts
     *
     * screen_height - Type: numeric. Desc: Height of client device screen
     *
     * screen_type - Type: string. Desc: the type of page in which the action was performed: category / search_results / main / home
     *
     * screen_width - Type: numeric. Desc: Width of client device screen
     *
     * search_guid - Type: guid. Desc: (optional) If from search results, GUID of matching search
     *
     * search_rank - Type: numeric. Desc: External ("like you") suggestion ranking
     *
     * sorting - Type: string. Desc: selected sorting
     *
     * styles - Type: string. Desc: list of selected styles
     *
     * sub_category - Type: string. Desc: List of subcategory filters
     *
     * openingSiteID - Type: guid. Desc: template_id
     *
     * total_search_results - Type: numeric. Desc: total search results from external ("like you") search suggestion
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     *
     * window_height - Type: numeric. Desc: Initial height of client window
     *
     * window_width - Type: numeric. Desc: Initial width of client window
     * @param {templatesVideoPreviewOpenParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesVideoPreviewOpen = function (params) {
        return this.bi.log(__assign({ evid: 65 }, params));
    };
    /**
    * @typedef {Object} templatesClosedDescriptionParams
    * @property {string} closed_from - "x button"- user clicked on x, "hover out" - user hovered out  of description
    * @property {number} galleryDocsPerPage - gallery docs per page
    * @property {GUID} tpsi - Templates Page Session ID
    **/
    /**
     * Name: templates -> closed description. Evid: 25.
    
    
     * closed_from - Type: string. Desc: "x button"- user clicked on x, "hover out" - user hovered out  of description
     *
     * galleryDocsPerPage - Type: numeric. Desc: gallery docs per page
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID
     * @param {templatesClosedDescriptionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesClosedDescription = function (params) {
        return this.bi.log(__assign({ evid: 25 }, params));
    };
    /**
    * @typedef {Object} templatesHoverOnTemplateParams
    * @property {number} avail_height - Returns the amount of horizontal space in pixels vertical to the window
    * @property {number} avail_width - Returns the amount of horizontal space in pixels available to the window
    * @property {string} book - book
    * @property {string} category - category
    * @property {string} colors - list of selected colors
    * @property {string} features - list of selected features
    * @property {number} index - gallery doc index
    * @property {number} galleryDocIndex - gallery doc index
    * @property {number} galleryDocsPerPage - gallery doc page
    * @property {number} hover_ms - hover duration in ms
    * @property {boolean} btn - is button
    * @property {string} layouts - list of selected layouts
    * @property {Url} openingbrowserurl - opening browse url
    * @property {string} origin - origin
    * @property {string} product - product
    * @property {number} screen_height - Height of client device screen
    * @property {string} screen_type - the type of page in which the action was performed: category / search_results / main / home
    * @property {number} screen_width - Width of client device screen
    * @property {number} siteType - site type
    * @property {string} sorting - selected sorting
    * @property {string} styles - list of selected styles
    * @property {string} sub_category - List of subcategory filters
    * @property {GUID} template_id - template id
    * @property {GUID} openingSiteID - template id
    * @property {GUID} tpsi - Templates Page Session ID (sticky for session, not refresh)
    * @property {DateTime} video_end_time - thumbnail video end timestamp
    * @property {number} video_full_duration - the full duration of this video in seconds (not how long it played by the user)
    * @property {number} video_playback_position - The position (timecode) in which the video was stopped, counting from the beginning or from the last looping of the video (in seconds)
    * @property {DateTime} video_start_time - thumbnail video start timestamp
    * @property {string} video_status - 'have_nothing', 'have_metadata', 'have_current_data', 'have_future_data', 'have_enough_data'
    * @property {boolean} videoThumbnail - template shows a video when hovering on the thumbnail (TRUE/FALSE)
    * @property {number} window_height - Initial height of client window
    * @property {number} window_width - Initial width of client window
    **/
    /**
     * Name: templates -> hover on template. Evid: 12.
     * Event description: when user hover on a template.
    
     * avail_height - Type: numeric. Desc: Returns the amount of horizontal space in pixels vertical to the window
     *
     * avail_width - Type: numeric. Desc: Returns the amount of horizontal space in pixels available to the window
     *
     * book - Type: string. Desc: book
     *
     * category - Type: string. Desc: category
     *
     * colors - Type: string. Desc: list of selected colors
     *
     * features - Type: string. Desc: list of selected features
     *
     * index - Type: numeric. Desc: gallery doc index
     *
     * galleryDocIndex - Type: numeric. Desc: gallery doc index
     *
     * galleryDocsPerPage - Type: numeric. Desc: gallery doc page
     *
     * hover_ms - Type: numeric. Desc: hover duration in ms
     *
     * btn - Type: bool. Desc: is button
     *
     * layouts - Type: string. Desc: list of selected layouts
     *
     * openingbrowserurl - Type: url. Desc: opening browse url
     *
     * origin - Type: string. Desc: origin
     *
     * product - Type: string. Desc: product
     *
     * screen_height - Type: numeric. Desc: Height of client device screen
     *
     * screen_type - Type: string. Desc: the type of page in which the action was performed: category / search_results / main / home
     *
     * screen_width - Type: numeric. Desc: Width of client device screen
     *
     * siteType - Type: numeric. Desc: site type
     *
     * sorting - Type: string. Desc: selected sorting
     *
     * styles - Type: string. Desc: list of selected styles
     *
     * sub_category - Type: string. Desc: List of subcategory filters
     *
     * template_id - Type: guid. Desc: template id
     *
     * openingSiteID - Type: guid. Desc: template id
     *
     * tpsi - Type: guid. Desc: Templates Page Session ID (sticky for session, not refresh)
     *
     * video_end_time - Type: datetime. Desc: thumbnail video end timestamp
     *
     * video_full_duration - Type: numeric. Desc: the full duration of this video in seconds (not how long it played by the user)
     *
     * video_playback_position - Type: numeric. Desc: The position (timecode) in which the video was stopped, counting from the beginning or from the last looping of the video (in seconds)
     *
     * video_start_time - Type: datetime. Desc: thumbnail video start timestamp
     *
     * video_status - Type: string. Desc: 'have_nothing', 'have_metadata', 'have_current_data', 'have_future_data', 'have_enough_data'
     *
     * videoThumbnail - Type: bool. Desc: template shows a video when hovering on the thumbnail (TRUE/FALSE)
     *
     * window_height - Type: numeric. Desc: Initial height of client window
     *
     * window_width - Type: numeric. Desc: Initial width of client window
     * @param {templatesHoverOnTemplateParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.templatesHoverOnTemplate = function (params) {
        return this.bi.log(__assign({ evid: 12 }, params));
    };
    /**
    * @typedef {Object} homePageStartNowButtonParams
    * @property {string} dest - null
    * @property {string} origin - null
    **/
    /**
     * Name: home page -> start now button. Evid: 18.
    
    
     * dest - Type: string.
     *
     * origin - Type: string.
     * @param {homePageStartNowButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.homePageStartNowButton = function (params) {
        return this.bi.log(__assign({ evid: 18 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
function getLoggerConf() {
    return {
        src: 2,
        endpoint: 'spettatore_bi'
    };
}
exports.getLoggerConf = getLoggerConf;
//# sourceMappingURL=index.js.map